module.exports = __webpack_public_path__ + "img/bg-4.f36c752e.jpg";